"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = undefined;
exports.errorReducer = errorReducer;

var _fp = require("lodash/fp");

var _fp2 = _interopRequireDefault(_fp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MAX_SIZE = 5;
// Log the last error-causing action in a character field.
var reducer = exports.reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments[1];
  return state;
};
function errorReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments[1];

  return _fp2.default.concat(_fp2.default.take(MAX_SIZE, state), [
  // jsonifying the action prevents serialization errors. A little wasteful,
  // but rare enough that it's okay.
  _fp2.default.omit(["root", "character"], JSON.parse(JSON.stringify(action)))]);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9zZWxlY3RvcnMvZmlyZWJhc2UvY2hhcmFjdGVyczIvYWN0aW9uLWVycm9ycy5qcyJdLCJuYW1lcyI6WyJlcnJvclJlZHVjZXIiLCJNQVhfU0laRSIsInJlZHVjZXIiLCJzdGF0ZSIsImFjdGlvbiIsImNvbmNhdCIsInRha2UiLCJvbWl0IiwiSlNPTiIsInBhcnNlIiwic3RyaW5naWZ5Il0sIm1hcHBpbmdzIjoiOzs7Ozs7UUFPZ0JBLFksR0FBQUEsWTs7QUFMaEI7Ozs7OztBQUVBLElBQU1DLFdBQVcsQ0FBakI7QUFIQTtBQUtPLElBQU1DLDRCQUFVLFNBQVZBLE9BQVU7QUFBQSxNQUFDQyxLQUFELHVFQUFnQixFQUFoQjtBQUFBLE1BQW9CQyxNQUFwQjtBQUFBLFNBQThDRCxLQUE5QztBQUFBLENBQWhCO0FBQ0EsU0FBU0gsWUFBVCxHQUFnRTtBQUFBLE1BQTFDRyxLQUEwQyx1RUFBM0IsRUFBMkI7QUFBQSxNQUF2QkMsTUFBdUI7O0FBQ3JFLFNBQU8sYUFBRUMsTUFBRixDQUFTLGFBQUVDLElBQUYsQ0FBT0wsUUFBUCxFQUFpQkUsS0FBakIsQ0FBVCxFQUFrQztBQUN2QztBQUNBO0FBQ0EsZUFBRUksSUFBRixDQUFPLENBQUMsTUFBRCxFQUFTLFdBQVQsQ0FBUCxFQUE4QkMsS0FBS0MsS0FBTCxDQUFXRCxLQUFLRSxTQUFMLENBQWVOLE1BQWYsQ0FBWCxDQUE5QixDQUh1QyxDQUFsQyxDQUFQO0FBS0QiLCJmaWxlIjoiYWN0aW9uLWVycm9ycy5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8vIEBmbG93XG4vLyBMb2cgdGhlIGxhc3QgZXJyb3ItY2F1c2luZyBhY3Rpb24gaW4gYSBjaGFyYWN0ZXIgZmllbGQuXG5pbXBvcnQgXyBmcm9tIFwibG9kYXNoL2ZwXCJcblxuY29uc3QgTUFYX1NJWkUgPSA1XG5leHBvcnQgdHlwZSBTdGF0ZSA9IE9iamVjdFtdXG5leHBvcnQgY29uc3QgcmVkdWNlciA9IChzdGF0ZTogU3RhdGUgPSBbXSwgYWN0aW9uOiBPYmplY3QpOiBTdGF0ZSA9PiBzdGF0ZVxuZXhwb3J0IGZ1bmN0aW9uIGVycm9yUmVkdWNlcihzdGF0ZTogU3RhdGUgPSBbXSwgYWN0aW9uOiBPYmplY3QpOiBTdGF0ZSB7XG4gIHJldHVybiBfLmNvbmNhdChfLnRha2UoTUFYX1NJWkUsIHN0YXRlKSwgW1xuICAgIC8vIGpzb25pZnlpbmcgdGhlIGFjdGlvbiBwcmV2ZW50cyBzZXJpYWxpemF0aW9uIGVycm9ycy4gQSBsaXR0bGUgd2FzdGVmdWwsXG4gICAgLy8gYnV0IHJhcmUgZW5vdWdoIHRoYXQgaXQncyBva2F5LlxuICAgIF8ub21pdChbXCJyb290XCIsIFwiY2hhcmFjdGVyXCJdLCBKU09OLnBhcnNlKEpTT04uc3RyaW5naWZ5KGFjdGlvbikpKSxcbiAgXSlcbn1cbiJdfQ==


//////////////////
// WEBPACK FOOTER
// ../core/lib/selectors/firebase/characters2/action-errors.js
// module id = 799
// module chunks = 0